module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-container"
  }, [_c('div', {
    staticClass: "header-line"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._t("header-right")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71637094!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseContainer.vue
// module id = 1070
// module chunks = 0